import gql from 'graphql-tag';

export const enableAccountMutation = gql`
  mutation ($input: AccountEnableInput) {
    enableAccount(input: $input)
    {
      accountId
    }
  }
`
